import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id EFD12742-D508-4531-A9A4-EDCF3148C748
 * name checkbox-intermediate
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-intermediate.svg
 * tags
 * - Form 
 */
export const CheckboxIntermediateIcon = createSvgIcon(<><path d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,17H7V7H17V17Z" /></>, 'CheckboxIntermediateIcon');
export default CheckboxIntermediateIcon